<template>
  <div class="scroll-top flex-center" :class="{ active: isClick, show: isShow }" @click="scrollTop">
    <img src="~@assets/img/scrollTop.png">
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  data() {
    return {
      speed: 150,
      isClick: false,
      isShow: false,
      prevTop: 0,
    }
  },
  mounted() {
    // window.addEventListener('scroll',e => {
    // 	const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    // 	const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    // 	this.isShow = scrollTop > windowHeight;
    // 	this.isClick = scrollTop <= this.prevTop;
    // 	setTimeout(()=>this.prevTop = scrollTop,0);
    // 	console.log('home')
    // },true)
    window.addEventListener('scroll', this.pageScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.pageScroll)
  },
  methods: {
    scrollTop() {
      if (!this.isClick) return
      document.documentElement.scrollTop -= this.speed;
      if (document.documentElement.scrollTop) {
        setTimeout(() => this.scrollTop(), 16);
      }
    },
    pageScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      this.isShow = scrollTop > windowHeight;
      this.isClick = scrollTop <= this.prevTop;
      setTimeout(() => this.prevTop = scrollTop, 0);
    }
  }
}
</script>

<style lang="scss">
.scroll-top {
  position: fixed;
  width: 40px;
  height: 40px;
  right: 54px;
  bottom: 54px;
  border-radius: 50%;
  background: #3ED8C4;
  transform: scale(0);
  transition: all 0.2s;
  user-select: none;
  z-index: 10;

  img {
    opacity: 0;
    width: 12px;
    transition: all 0.1s;
  }

  &.show {
    // transform: scale(0.5);

    &.active {
      transform: scale(1);
      cursor: pointer;

      img {
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/scrollTop.vue